import { render, staticRenderFns } from "./detail_happiness_tips_categories_page.vue?vue&type=template&id=1bd50e13&scoped=true"
import script from "./detail_happiness_tips_categories_page.vue?vue&type=script&lang=js"
export * from "./detail_happiness_tips_categories_page.vue?vue&type=script&lang=js"
import style0 from "./detail_happiness_tips_categories_page.vue?vue&type=style&index=0&id=1bd50e13&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd50e13",
  null
  
)

export default component.exports